import React from 'react';

const PageSubcaption = (props) => {
  const caption = props.caption;
  return (
    <div className="fix-widthed page-subcaption">
      <h5 className="page-subtitle">
        {caption}
      </h5>
    </div>
  );
};

export default PageSubcaption;



// WEBPACK FOOTER //
// ./src/containers/layouts/MainLayout/PageSubcaption.jsx